
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.1486 2.96997L22.3986 12.07C22.9486 13.01 22.9486 14.13 22.3986 15.07C21.8586 16.01 20.8886 16.57 19.8086 16.57H16.5385C16.5385 16.57 16.5385 16.57 16.5385 16.57C15.7185 19.99 12.6285 22.53 8.96848 22.53C4.67848 22.53 1.18848 19.03 1.18848 14.74C1.18848 10.45 4.67848 6.96002 8.96848 6.96002C9.19848 6.96002 9.41848 6.97002 9.63848 6.99002C9.6385 6.99002 9.63852 6.99003 9.63855 6.99003L9.63858 6.98997L11.9586 2.96997C12.4986 2.02997 13.4586 1.46997 14.5486 1.46997C15.6386 1.46997 16.6086 2.02997 17.1486 2.96997ZM14.6685 16.57H9.29858C8.20858 16.57 7.23858 16.01 6.69858 15.07C6.15858 14.13 6.15858 13.01 6.69858 12.07L8.59856 8.78001C8.59853 8.78001 8.5985 8.78002 8.59848 8.78002C5.46848 8.96002 2.98848 11.44 2.98848 14.74C2.98848 18.04 5.66848 20.73 8.96848 20.73C11.6285 20.73 13.8985 18.98 14.6685 16.57C14.6685 16.57 14.6685 16.57 14.6685 16.57ZM19.8086 14.77C20.2386 14.77 20.6286 14.55 20.8486 14.17C20.9486 13.99 21.1586 13.51 20.8486 12.97L15.5886 3.86997C15.3786 3.49997 14.9886 3.26997 14.5486 3.26997C14.3386 3.26997 13.8286 3.32997 13.5086 3.86997L11.4886 7.37997L10.5586 8.97997L8.25858 12.97C8.03858 13.35 8.03858 13.79 8.25858 14.17C8.47858 14.55 8.85858 14.77 9.29858 14.77H19.8086Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M11.9567 2.97101C13.1114 0.971005 15.9981 0.971012 17.1528 2.97101L22.4065 12.0706C23.5612 14.0706 22.1178 16.5706 19.8084 16.5706H9.3011C6.9917 16.5706 5.54833 14.0706 6.70303 12.0706L11.9567 2.97101Z","fill":"#5D5CFD"}})])
          )
        }
      }
    